import { render, staticRenderFns } from "./cardLessonsColumn.vue?vue&type=template&id=588a6044&scoped=true&lang=pug&"
import script from "./cardLessonsColumn.vue?vue&type=script&lang=js&"
export * from "./cardLessonsColumn.vue?vue&type=script&lang=js&"
import style0 from "./cardLessonsColumn.vue?vue&type=style&index=0&id=588a6044&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a6044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
